/**
 * 「最新の版に更新」ボタン(2026-10-14 発注者指示「システム内に更新ボタン」)。トップバーに置く。
 * 本番の /version.json(マージのたびに変わる)を見て、いま開いている画面の版(__BUILD_COMMIT__)と違えば「新しい版があります」と目立たせる。
 * 押すとページを読み直して最新の版にする(入力中の内容は各画面の未保存の確認が出る)。
 * 版の確認は 開いたとき・5分ごと・画面に戻ってきたとき。手元の開発サーバーでは version.json が無いので、ボタンは押せるが印は出ない。
 */
import { useCallback, useEffect, useState } from 'react';

const CHECK_MS = 5 * 60 * 1000;

export default function AppUpdateButton() {
  const [latest, setLatest] = useState<string | null>(null);

  const check = useCallback(async () => {
    try {
      const res = await fetch(`/version.json?t=${Date.now()}`, { cache: 'no-store' });
      if (!res.ok) return;
      const v = (await res.json()) as { commit?: string };
      if (typeof v.commit === 'string' && v.commit) setLatest(v.commit);
    } catch {
      // 版の確認に失敗しても画面は使える(ボタンは押せる)
    }
  }, []);

  useEffect(() => {
    void check();
    const timer = window.setInterval(() => void check(), CHECK_MS);
    const onVisible = () => {
      if (document.visibilityState === 'visible') void check();
    };
    document.addEventListener('visibilitychange', onVisible);
    return () => {
      window.clearInterval(timer);
      document.removeEventListener('visibilitychange', onVisible);
    };
  }, [check]);

  const hasNew = latest !== null && latest !== __BUILD_COMMIT__;
  return (
    <button
      type="button"
      className={`ui-btn ui-btn-sm ${hasNew ? 'ui-btn-primary' : 'ui-btn-secondary'} app-update-btn`}
      title={hasNew ? `新しい版(${latest})があります。押すと最新の版に切り替わります` : 'ページを読み直して最新の状態にします'}
      onClick={() => window.location.reload()}
    >
      {hasNew ? '新しい版に更新' : '再読み込み'}
    </button>
  );
}
